import api from '../../service/modules/feedback'

export default {
    namespaced: true,
    state: {
        componentIndex: 1,
    },
    getters: {
        
    },
    mutations: {
        setComponentIndex(state, data) {
            state.componentIndex = data;
        }
    },
    actions: {
        
        getUploadUrl: (context, data) => {
            return new Promise((resolve, reject) => {
                api.getUploadUrl(data).then(res => {
                    resolve(res.data)
                }).catch(res=>{
                    reject(res.data)
                });
            })
            
        },
    }
}